import { baseApi } from './baseApi';

export type FavoriteTargetType = 'shop' | 'stylist';

export interface FavoriteRecord {
  id: string;
  customerId: string;
  targetType: FavoriteTargetType | Uppercase<FavoriteTargetType>;
  targetId: string;
  createdAt: string;
}

export const favoritesApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    /** Both populations in one call — used to seed the app-wide heart state. */
    getFavorites: builder.query<FavoriteRecord[], void>({
      query: () => '/favorites/me',
      providesTags: ['Favorite'],
    }),
    addFavorite: builder.mutation<FavoriteRecord, { targetType: FavoriteTargetType; targetId: string }>({
      query: (body) => ({ url: '/favorites', method: 'POST', body }),
      invalidatesTags: ['Favorite'],
    }),
    removeFavorite: builder.mutation<void, { targetType: FavoriteTargetType; targetId: string }>({
      query: ({ targetType, targetId }) => ({
        url: `/favorites/${targetType}/${encodeURIComponent(targetId)}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Favorite'],
    }),
  }),
});

export const {
  useGetFavoritesQuery,
  useAddFavoriteMutation,
  useRemoveFavoriteMutation,
} = favoritesApi;
